export const EI_SEARCH_BAR_DEFAULTS = {
    width: '100%',
    placeholder: 'Search',
    iconSrc: 'assets/icons/search.svg',
    enterKey: 'Enter',
} as const
